export const pricingModelTypes = {
  CPA: 'cpa',
  CPC: 'cpc',
  CPM: 'cpm',
  CPM_GOAL: 'cpm goal',
  CPC_GOAL: 'cpc goal'
}
